import { connect } from 'react-redux';
import { getFavoriteDestinations, createFavoriteDestinations, deleteFavoriteDestinationById, resetMeta, resetPage } from '../../actions/FavoriteDestinationListPage';
// import { resetPage as resetListPage } from '../../actions/ApplicationListPage';
import FavoriteDestinationListPage from './FavoriteDestinationListPage';

const mapsStateToProps = state => ({
	pageProps: state.favoriteDestinationListPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getFavoriteDestinations() {
		dispatch(getFavoriteDestinations());
	},
	createFavoriteDestinations(options) {
		dispatch(createFavoriteDestinations(options));
	},
	deleteFavoriteDestinationById(id) {
		dispatch(deleteFavoriteDestinationById(id));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(FavoriteDestinationListPage);
